function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -4.008)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M230.548,223.248l-7.522-7.522a2.33,2.33,0,0,0-2.682-.439l-1.925-1.925a10.271,10.271,0,1,0-1.049,1.049l1.925,1.925a2.33,2.33,0,0,0,.439,2.682l7.522,7.522a2.328,2.328,0,1,0,3.292-3.292Zm-28.661-16.594a8.775,8.775,0,1,1,8.775,8.775A8.784,8.784,0,0,1,201.887,206.654Zm18.648,10.718a.844.844,0,0,1,1.441-.6l.653.653-1.194,1.194-.653-.653a.839.839,0,0,1-.247-.6Zm8.963,8.119a.844.844,0,0,1-1.194,0l-5.82-5.82,1.194-1.194,5.82,5.82a.844.844,0,0,1,0,1.194Z",
  transform: "translate(-181.23 -173.215)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M268.03,228.46a7.076,7.076,0,0,0-3.6.987.742.742,0,1,0,.755,1.278,5.593,5.593,0,0,1,7.663,7.663.742.742,0,1,0,1.278.755,7.077,7.077,0,0,0-6.1-10.681Z",
  transform: "translate(-238.376 -202.166)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.395,268.844a5.593,5.593,0,0,1-7.663-7.663.742.742,0,0,0-1.278-.755,7.077,7.077,0,0,0,9.695,9.7.742.742,0,0,0-.755-1.278Z",
  transform: "translate(-209.849 -230.63)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.409,44.089H40.823a.742.742,0,0,0,0,1.484h1.586a.742.742,0,0,0,0-1.484Z",
  transform: "translate(-36.116 -36.116)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.694,44.831a.742.742,0,0,0-.742-.742H88.919a.742.742,0,1,0,0,1.484h19.033A.742.742,0,0,0,108.694,44.831Z",
  transform: "translate(-79.643 -36.116)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.823,156.315a.742.742,0,0,0,0,1.484h1.586a.742.742,0,0,0,0-1.484Z",
  transform: "translate(-36.116 -137.195)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.919,156.315a.742.742,0,0,0,0,1.484h19.033a.742.742,0,0,0,0-1.484Z",
  transform: "translate(-79.643 -137.195)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.982,26.213H17.345V24.525h4.413a.742.742,0,1,0,0-1.484H2.328a.845.845,0,0,1-.844-.844V17.439a.845.845,0,0,1,.844-.844h28.55a.845.845,0,0,1,.844.844v3.172a.742.742,0,0,0,1.484,0V17.439a2.331,2.331,0,0,0-2.328-2.328H17.345V13.423H30.878a2.331,2.331,0,0,0,2.328-2.328V6.336a2.331,2.331,0,0,0-2.328-2.328H2.328A2.331,2.331,0,0,0,0,6.336v4.758a2.331,2.331,0,0,0,2.328,2.328H15.861v1.688H2.328A2.331,2.331,0,0,0,0,17.439V22.2a2.331,2.331,0,0,0,2.328,2.328H15.861v1.688H2.328A2.331,2.331,0,0,0,0,28.541V33.3a2.331,2.331,0,0,0,2.328,2.328H17.4a.742.742,0,1,0,0-1.484H2.328a.845.845,0,0,1-.844-.844V28.541a.845.845,0,0,1,.844-.844H18.982a.742.742,0,1,0,0-1.484ZM1.484,11.094V6.336a.845.845,0,0,1,.844-.844h28.55a.845.845,0,0,1,.844.844v4.758a.845.845,0,0,1-.844.844H2.328a.845.845,0,0,1-.844-.844Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.823,268.54a.742.742,0,0,0,0,1.484h1.586a.742.742,0,0,0,0-1.484Z",
  transform: "translate(-36.116 -238.286)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.919,268.54a.742.742,0,1,0,0,1.484H96.85a.742.742,0,1,0,0-1.484Z",
  transform: "translate(-79.592 -238.286)"
}));

function SvgMylist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylist);
export default __webpack_public_path__ + "static/media/mylist.9fc59e19.svg";
export { ForwardRef as ReactComponent };